// extracted by mini-css-extract-plugin
module.exports = {"member":"index__member___3yQGp","triangle":"index__triangle___2k9Te","wrap":"index__wrap___iQX4b","option":"index__option___3SC4A"};